import { MsalProvider, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { configureStore } from '@reduxjs/toolkit';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import artifactsReducer from 'artifactsSlice';
import chatBotEventsSliceRecucer from 'chatBotEventsSlice';
import homeVisibilityReducer from 'components/Home/homeVisibilitySlice';
import loadingPhraseReducer from 'loadingPhraseSlice';
import skillsReducer from 'components/skills/skillsSlice';
import toggleSideNavReducer from 'shared/components/SideNav/SideNavToggleButton/toggleSideNav';
import userSendPromptReducer from 'shared/components/SideNav/userSendPromptSlicer';

import App from './App';
import guidePromptsReducer from './components/Prompts/Guide/GuidePromptsSearcher/guidePromptsSlice';
import cardTextSliceReducer from './shared/components/Cards/Card/cardTextSlice';
import modalActionsReducer from './shared/components/Modal/modalActionsSlice';
import { msalInstance } from './shared/functions/authConfig';

import "./index.css";

const store = configureStore({
  reducer: {
    homeVisibility: homeVisibilityReducer,
    cardText: cardTextSliceReducer,
    chatBotEvents: chatBotEventsSliceRecucer,
    loadingPhrase: loadingPhraseReducer,
    artifacts: artifactsReducer,
    skills: skillsReducer,
    modalActions: modalActionsReducer.modalActionsSlice,
    modalComponents: modalActionsReducer.modalComponentSlice,
    toggleSideNav: toggleSideNavReducer,
    guidePrompsSearcher: guidePromptsReducer,
    userSendPrompt: userSendPromptReducer.userSendPromptSlice
  }
})

const domNode = document.getElementById('root') as HTMLElement;
const root = createRoot(domNode);

root.render(
  // <MsalProvider instance={msalInstance}>
    <FluentProvider theme={webLightTheme}>
      <Provider store={store}>
        <App />
      </Provider>
    </FluentProvider>
  // </MsalProvider>
);